import { ClaimWithCheckoutRelationsDTO } from '@reposit/api-client';
import moment from 'moment';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import {
  DocumentIdCell,
  DocumentTable,
  documentTypeLabel,
  EvidenceWorkspaceDocumentLink,
  useCanOpenEvidenceWorkspace,
} from '../EvidenceWorkspaceDocumentLink';
import SecondaryPanel from '../SecondaryPanel';
import { Tbody, Td, Thead, Tr } from '../Table';
import { A, Header4, P1, P2 } from '../Typography';

export enum ClaimResponseStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  AWAITING_RESPONSE = 'AWAITING_RESPONSE',
}

interface ClaimResponseProps {
  claim: ClaimWithCheckoutRelationsDTO;
}

/* User	Accepted	Description	Responded At	Amount Paid	Paid At  */

const ResponseTitle = styled(Header4)`
  margin: 0 0 6px;
`;

const EvidenceTitle = styled(Header4)`
  margin: 24px 0 12px;
`;

const DisputeInformation: React.FC<ClaimResponseProps> = ({ claim }) => {
  const tenantDisputeMessage = claim.tenantDisputeMessage;
  const showEvidenceWorkspace = useCanOpenEvidenceWorkspace();

  return (
    <SecondaryPanel>
      {tenantDisputeMessage ? (
        <Fragment>
          <ResponseTitle>Dispute Message:</ResponseTitle>
          <P1>{tenantDisputeMessage}</P1>
        </Fragment>
      ) : (
        <P2>No dispute message provided</P2>
      )}
      <EvidenceTitle>Evidence:</EvidenceTitle>
      {claim.responseDocuments && claim.responseDocuments.length > 0 ? (
        claim.responseDocuments.map(({ document }) => (
          <DocumentTable key={document.id}>
            <Thead>
              <Tr>
                <Td>ID</Td>
                <Td>Name</Td>
                <Td>Type</Td>
                <Td>Uploaded At</Td>
                <Td>Action</Td>
                {showEvidenceWorkspace ? <Td>Evidence workspace</Td> : null}
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <DocumentIdCell>{document.id}</DocumentIdCell>
                <Td>{document.name}</Td>
                <Td>{documentTypeLabel(document.typeId)}</Td>
                <Td>{moment(document.createdAt).format('DD/MM/YYYY HH:mm:ss')}</Td>
                <Td>
                  <A target="_blank" href={document.url}>
                    View
                  </A>
                </Td>
                {showEvidenceWorkspace ? (
                  <Td>
                    <EvidenceWorkspaceDocumentLink documentId={document.id} documentName={document.name} />
                  </Td>
                ) : null}
              </Tr>
            </Tbody>
          </DocumentTable>
        ))
      ) : (
        <Fragment>
          <P2>No evidence provided</P2>
        </Fragment>
      )}
    </SecondaryPanel>
  );
};

export default DisputeInformation;
